const CouponModal = ({ closeModal }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Create New Coupon</h2>
            <form className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Coupon Code</label>
                    <input type="text" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500" placeholder="e.g., WINTER30" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Discount Type</label>
                    <select className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500">
                        <option>Percentage</option>
                        <option>Fixed Amount</option>
                        <option>Free Delivery</option>
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Discount Value</label>
                    <input type="text" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500" placeholder="e.g., 30 or 10" />
                </div>
                <div className="flex justify-end space-x-4 pt-4">
                    <button type="button" onClick={closeModal} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button type="submit" className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-semibold">Create</button>
                </div>
            </form>
        </div>
    </div>
);

export default CouponModal;